module.exports = __webpack_public_path__ + "_/_/src/assets/firesafety/Running-Man-Door-Symbol-Left/legend.png";